<!--耗金额统计-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="140px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="queryParam.searchDay"
              type="daterange"
              range-separator=""
              start-placeholder="开始"
              value-format="yyyy-MM-dd"
              end-placeholder="结束">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div></div>
    </div>
    <el-card class="table-container" shadow="never" style="margin-top: 0px;">
      <div class="op-con">
        <el-radio-group  v-model="radio" @change="onChangeDay">
          <el-radio :label="index" v-for="(item, index) in redioDayRange" :key="index">{{item.dayDes}}</el-radio>
        </el-radio-group>
        <span class="op-title">(点击立即查询)</span>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        max-height="500"
        v-loading="listLoading" border>
        <el-table-column prop="dayTime" label="日期" ></el-table-column>
        <el-table-column prop="money" label="消费金额" ></el-table-column>
        <el-table-column prop="rate" label="占比"></el-table-column>
      </el-table>
    </el-card>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
  .op-con{
    width: 90%;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fcf4e9;
    border-radius: 8px;
    margin-left: 5%;
  }
  .op-title{
    font-size: 14px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: #0d6fb8;
    margin-left: 30px;
  }
</style>

<script>



  import {formatDate} from "../../../utils/date";
  import timeUtils from "../../../utils/timeUtils";

  import commonUtils from "../../../utils/commonUtils";
  import globaldata from "../../../utils/globaldata";
  import enumsUtil from "../../../utils/enumsUtil";
  import {queryBdConsumeTimesDetail, queryBdConsumeTimesMoneyRate} from "../../../api/bd/BaseData";

  export default {
    data() {
      return {
        listLoading: true,
        tableData:[],
        queryParam :{
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          searchDay :[],
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        radio:0,
        redioDayRange:[
          {day:[], dayDes:'本周'},
          {day:[], dayDes:'本月'},
          {day:[], dayDes:'近30天'},
          {day:[], dayDes:'近60天'},
          {day:[], dayDes:'近半年'},
          {day:[], dayDes:'上半年'},
          {day:[], dayDes:'下半年'},
          {day:[], dayDes:'今年'},
        ],
        redioDay:null,

      }
    },
    created() {
      let now = new Date();
      let monday = timeUtils.getFirstDayOfWeek(now); //周一
      this.queryParam.searchDay = [];
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.initRedioDayRange();
      this.fitchData();
    },
    methods: {
      handleSizeChange(val){
        this.queryParam.pageNum = 1;
        this.queryParam.pageSize = val;
        this.fitchData();
      },
      handleCurrentChange(val){
        this.queryParam.pageNum = val;
        this.fitchData();
      },

      initRedioDayRange(){
        this.redioDayRange = [];
        let now = new Date();
        let monday = timeUtils.getFirstDayOfWeek(now); //周一
        let rangeItem = {
          day:[formatDate(monday,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本周"
        }
        this.redioDayRange.push(rangeItem);

        let fm = timeUtils.getFirstDayOfMonth(now); //
        let rangeItemFn = {
          day:[formatDate(fm,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本月"
        }
        this.redioDayRange.push(rangeItemFn);

        let bf30 = timeUtils.getBeforeDayOfDate(now,30);
        let rangeItembf30 = {
          day:[formatDate(bf30,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近30天"
        }
        this.redioDayRange.push(rangeItembf30);

        let bf60 = timeUtils.getBeforeDayOfDate(now,60);
        let rangeItembf60 = {
          day:[formatDate(bf60,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近60天"
        }
        this.redioDayRange.push(rangeItembf60);



        let bhe = timeUtils.getFirstDayOfHYear(now);
        let rangeItembfHBY = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(bhe[1],"yyyy-MM-dd")],
          dayDes:"上半年"
        }
        this.redioDayRange.push(rangeItembfHBY);

        let ahe = timeUtils.getFirstDayOfLYear(now);

        let rangeItembfABY = {
          day:[formatDate(ahe[0],"yyyy-MM-dd"),formatDate(ahe[1],"yyyy-MM-dd")],
          dayDes:"下半年"
        }

        this.redioDayRange.push(rangeItembfABY);

        let rangeItembfAlly = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"全年"
        }
        this.redioDayRange.push(rangeItembfAlly);


      },

      //点击查询按钮
      onBtnSearch(){
        this.fitchData();
      },
      fitchData(){
        this.listLoading = true;
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:enumsUtil.lessonTemplateIdCF(),
          startDay:this.queryParam.searchDay[0],
          endDay :this.queryParam.searchDay[1],
        }
        const loading = this.myLoading();
        queryBdConsumeTimesMoneyRate(param).then(response => {
          this.listLoading = false;
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      refreshData(list){
        list.sort(function(a,b){
          return a.dayTime-b.dayTime});
        let totalMoney  = 0;
        for (let i = 0;i< list.length;++i){
          totalMoney += list[i].money;
          list[i].money =  list[i].money.toFixed(2);

        }

        this.tableData = list;
        for (let i = 0;i<   this.tableData.length;++i){
          let rate = this.tableData[i].money*100/totalMoney;
          rate =  rate.toFixed(2);
          this.tableData[i].dayTime = timeUtils.transDay( this.tableData[i].dayTime)
          this.tableData[i].rate =  rate+"%"
        }
      },

      onChangeDay(val){
        let day = this.redioDayRange[val].day;
        this.queryParam.searchDay = [];
        this.queryParam.searchDay.push(day[0]);
        this.queryParam.searchDay.push(day[1]);
        this.fitchData();

      },



    }
  }
</script>






// WEBPACK FOOTER //
// src/views/base-data/bd-analysis-time/index.vue